import { TFunction } from 'react-i18next';
import * as Yup from 'yup';

import {
  couponCodeRegularExpression,
  emailIdRegularExpression,
  otpRegularExpression,
  phoneNumberRegularExpression
} from '@nw/shared/utils';

export const UserRoleDetailsFormInputFieldValidationSchema = (
  t: TFunction,
  userRole: string,
  alreadyLoginInPhoneNumber: string | undefined
): Yup.AnyObjectSchema => {
  return Yup.object().shape({
    userName: Yup.string().required(t('validationMessages.required')),

    userEmail: Yup.string()
      .trim()
      .test(
        'is-valid-email',
        t('validationMessages.notAValidEmail'),
        (value) => {
          if (value && value.length > 0) {
            return emailIdRegularExpression.test(value);
          }
          return true;
        }
      ),
    user12thCompletionYear: Yup.string()
      .trim(t('validationMessages.required'))
      .required(t('validationMessages.required')),

    studentName:
      userRole === 'PARENT'
        ? Yup.string().required(t('validationMessages.required'))
        : Yup.string().notRequired(),

    studentEmail:
      userRole === 'PARENT'
        ? Yup.string()
            .trim()
            .test(
              'is-valid-student-email',
              t('validationMessages.notAValidEmail'),
              (value) => {
                if (value && value.length > 0) {
                  return emailIdRegularExpression.test(value);
                }
                return true;
              }
            )
        : Yup.string().notRequired(),

    phoneNumber:
      userRole === 'PARENT'
        ? Yup.string()
            .required(t('validationMessages.required'))
            .matches(
              phoneNumberRegularExpression,
              t('validationMessages.invalidPhoneNumber')
            )
            .test(
              'not-equal-to-already-logged-in-phone',
              'Phone Number should not be same as parent phone number',
              function (value) {
                return value !== alreadyLoginInPhoneNumber;
              }
            )
        : Yup.string().notRequired(),

    otp:
      userRole === 'PARENT'
        ? Yup.string()
            .required(t('validationMessages.required'))
            .matches(otpRegularExpression, t('validationMessages.invalidOtp'))
        : Yup.string().notRequired(),
    currentEducation: Yup.string().required(t('validationMessages.required')),
    stream: Yup.string().required(t('validationMessages.required'))
  });
};

export const ApplicationProductFieldValidationSchema = (
  t: TFunction
): Yup.AnyObjectSchema => {
  return Yup.object().shape({
    couponCode: Yup.string()
      .transform((value, originalValue) => {
        if (value === '') return null;
        return originalValue;
      })
      .matches(couponCodeRegularExpression, 'Enter a valid coupon code')
      .nullable(),
    stateOfResidence: Yup.string()
      .trim()
      .required(t('validationMessages.required')),
    nxtwaveTermsAndConditions: Yup.bool().oneOf(
      [true],
      t('validationMessages.required')
    ),
    communicationConsent: Yup.bool().oneOf(
      [true],
      t('validationMessages.required')
    )
  });
};
